import { render, staticRenderFns } from "./ApplicationCard.vue?vue&type=template&id=2f0e61db&scoped=true"
import script from "./ApplicationCard.vue?vue&type=script&lang=js"
export * from "./ApplicationCard.vue?vue&type=script&lang=js"
import style0 from "./ApplicationCard.vue?vue&type=style&index=0&id=2f0e61db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0e61db",
  null
  
)

export default component.exports